import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class RcmPublishLifecycleRequest implements ViewModel {
  readonly friendlyTypeNameSingular = 'RCM Publish Request';
  apiRoute: string = CONFIG.apiRoutes.rcmPublish;

  modelName: string = 'maintenance-library_';
  modelId: string;
  equipmentLibraryIds: string[] = [];
  maintenanceStrategyIds: string[] = [];
  plannedMaintenanceIds: string[] = [];
  performanceStandardIds: string[] = [];
  publishOnSuccess: boolean;

  public json(): any {
    return this;
  }

  loadFromJson(data) {
    this.modelId = data.modelId;
    this.publishOnSuccess = data.publishOnSuccess;

    if (data.equipmentLibraryIds) {
      this.equipmentLibraryIds = data.equipmentLibraryIds;
    }

    if (data.maintenanceStrategyIds) {
      this.maintenanceStrategyIds = data.maintenanceStrategyIds;
    }

    if (data.plannedMaintenanceIds) {
      this.plannedMaintenanceIds = data.plannedMaintenanceIds;
    }

    if (data.performanceStandardIds) {
      this.performanceStandardIds = data.performanceStandardIds;
    }
  }
}

export class RcmPublishRequest extends RcmPublishLifecycleRequest {
  constructor() {
    super();
    this.apiRoute = CONFIG.apiRoutes.rcmPublish;
  }
}

export class RcmDownloadRequest extends RcmPublishLifecycleRequest {
  constructor() {
    super();
    this.apiRoute = CONFIG.apiRoutes.rcmLibraryPackageDownload;
  }
}
